function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_8472)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_114_8472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77212 13.6158L0.46165 11.4629C-0.476457 11.0826 -0.458851 9.74828 0.488964 9.39284L14.3896 4.18011C15.2828 3.84516 16.155 4.71741 15.8201 5.61061L10.6074 19.5112C10.2519 20.4591 8.91759 20.4767 8.53728 19.5386L6.38438 14.2281C6.27149 13.9496 6.05061 13.7287 5.77212 13.6158ZM6.3983 12.0713L2.40755 10.4534L13.8304 6.16981L9.54682 17.5927L7.92895 13.6019C7.89556 13.5195 7.8584 13.4392 7.81766 13.3611L10.7858 10.3929C11.1113 10.0675 11.1113 9.53985 10.7858 9.21441C10.4604 8.88897 9.93276 8.88897 9.60732 9.21441L6.63917 12.1826C6.56103 12.1418 6.48067 12.1046 6.3983 12.0713Z",
    fill: "#002CFB",
    style: {
      fill: "#002CFB",
      fill: "color(display-p3 0.0000 0.1725 0.9843)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_8472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_114_8472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/iconSend.616e3eebf7788f785127ecea48542307.svg";
export { ForwardRef as ReactComponent };